import './full-size.css';


// TODO: PropsWithChildren
const FullSize = ({ bgColor, children }: any) => {
  return (
    <div className="full_size" style={{ background: bgColor }}>
      {children}
    </div>
  )
}

export default FullSize;
